export const SOURCE_TABLE_CLASS_NAME = "w-full border-collapse font-headings";

export const SOURCE_TH_CLASS_NAME =
  "text-left text-[10px] font-semibold text-muted-foreground uppercase tracking-wider whitespace-nowrap bg-muted px-3 py-2 border-b border-border sticky top-0 z-10 font-headings";

export const SOURCE_TD_CLASS_NAME =
  "px-3 py-2 text-[12px] text-foreground font-medium border-b border-border min-w-[120px] max-w-[400px] [tr:last-child_&]:border-b-0 [tr:hover_&]:bg-muted font-headings";
